import React from "react";
import CloseMenuIcon from "../../resources/wrappers/menu/CloseMenuIcon";
import { AppUtils } from "../../utils/AppUtils";
import './ImageCropper.css';
import $ from 'jquery';
import { Button } from "@material-ui/core";
import { eventDispatcher } from "../../services/events/EventDispatcher";
import { EventType } from "../../services/events/EventType";
import { EventWithData } from "../../services/events/EventWithData";
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css'; // see installation section above for versions of NPM older than 3.0.0
import Media from "react-media";
// If you choose not to use import, you need to assign Cropper to default
// var Cropper = require('react-cropper').default

export class ImageCropper extends React.Component<any, any> {
    readonly MAX_IMAGE_WIDTH_DESKTOP = 1024;
    readonly MAX_IMAGE_HEIGHT_DESKTOP = 768;
    private eventSubscription: any = null;
    private cropper: any;
    constructor(props: any){
        super(props);
        // Image uploaded is a base64 string
        this.state = {
            imageDesktop: '',
            imageMobile: '',
            imageCropped: '',
            innerWidth: 0,
            isMobile: false,
            baseInput: ''
        }

        this.manageResizeView = this.manageResizeView.bind(this);
    }

    componentDidMount(){
        console.log("[ImageCropper] did mount");
        if($("#desktop-footer-body") !== null && $("#desktop-footer-body") !== undefined){
            $("#desktop-footer-body").hide();
        }

        this.eventSubscription = eventDispatcher.getEventAndDataObserver().subscribe((eventAndData: EventWithData) => {
            if(EventType.IMAGE_CROP_FINISHED === eventAndData.eventType){
                // @ts-ignore
                let data = eventAndData.data.cropped;
                this.props.closeFunctionWithResult(this.buildResult(true, data));
            }
        }, () => { });
 
        if(this.props.input !== undefined){
            this.toBase64(this.props.input).then((result) => {
                this.setState({baseInput: result}, () => {
                    this.resizeImageDesktop(this.state.baseInput);
                    this.setState({innerWidth: window.innerWidth}, () => {
                        if(this.state.innerWidth >= 1065){
                            console.log('ImageCropper -> Desktop')
                            this.setState({isMobile: false});
                        } else {
                            console.log('ImageCropper -> Mobile')
                            this.setState({isMobile: true});
                        }
                    })
                });
            }).catch(error => console.error(error));
        }

        window.addEventListener('resize', this.manageResizeView);
    }

    componentWillUnmount(){
        console.log("[ImageCropper] will unmount");
        if($("#desktop-footer-body") !== null && $("#desktop-footer-body") !== undefined){
            $("#desktop-footer-body").show();
        }

        if(this.eventSubscription !== null){
            this.eventSubscription.unsubscribe();
        }

        window.removeEventListener('resize', this.manageResizeView);
    }

    componentDidUpdate(){
        if($("#desktop-footer-body") !== null && $("#desktop-footer-body") !== undefined){
            $("#desktop-footer-body").hide();
        }
    }

    private manageResizeView(){
        this.setState({innerWidth: window.innerWidth}, () => {
            if(this.state.innerWidth >= 1065){
                console.log('ImageCropper -> Desktop')
                this.setState({isMobile: false});
            } else {
                console.log('ImageCropper -> Mobile')
                this.setState({isMobile: true});
            }
        })
    }

    private toBase64 = (file: any) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    private buildResult(res: boolean, image?: string): any {
        return {
            result: res,
            image: image
        };
    }

    private _crop() {
        // image in dataUrl
       let image = this.cropper.getCroppedCanvas({
            imageSmoothingEnabled: false,
            imageSmoothingQuality: 'high'
        }).toDataURL();
        this.setState({imageCropped: image});
    }

    private onCropperInit(cropper: any) {
        this.cropper = cropper;
    }

    resizeImageDesktop(imageSrc: any) {
        var img = new Image;
        img.onload = () => {
            var scale, newWidth, newHeight, canvas, ctx;
            if(img.width < this.MAX_IMAGE_WIDTH_DESKTOP){
                scale = this.MAX_IMAGE_WIDTH_DESKTOP/img.width;
            } else {
                scale = this.MAX_IMAGE_HEIGHT_DESKTOP/img.height;
            }
            newWidth = img.width * scale;
            newHeight = (img.height * scale);
            if(newHeight > 600){
                let newScale = (scale * 600)/newHeight;
                newHeight = img.height * newScale;
                newWidth = img.width * newScale;
            }
            canvas = document.createElement('canvas');
            canvas.height = newHeight;
            canvas.width = newWidth;
            ctx = canvas.getContext('2d');
            //@ts-ignore
            ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, newWidth, newHeight);
            this.setState({imageDesktop: canvas.toDataURL()});
        };
        img.src = imageSrc;
    }

    private sendOutput(){
        eventDispatcher.sendEventWithData(EventType.IMAGE_CROP_FINISHED, {cropped: this.state.imageCropped});
    }

    render(){
        return [<Media query="(min-width: 1065px)" render={() => {
            return <div id={"main-cropper-container"}>
                <div id={"image-cropper-main-container-header"} onClick={() => this.props.closeFunctionWithResult(this.buildResult(false, undefined))}>
                    <CloseMenuIcon width={'21px'} height={'21px'} fill={'#FFFFFF'} />
                </div>
                {<Cropper
                    src={this.state.imageDesktop}
                    // Cropper.js options
                    initialAspectRatio={16/9}
                    guides={false}
                    center={true}
                    background={false}
                    responsive={true}
                    crop={this._crop.bind(this)}
                    onInitialized={this.onCropperInit.bind(this)}
                    cropBoxResizable={true}
                    cropBoxMovable={true}
                    zoomable={false}
                    movable={true}
                    rotatable={false}
                    toggleDragModeOnDblclick={false}
                    viewMode={2}
                    aspectRatio={1}
                    modal={true}
                    minCropBoxHeight={600}
                    minCropBoxWidth={600}
                />}
                <div id={"image-cropper-button-container"}> 
                    <Button id={"image-cropper-button-confirm"} disabled={this.state.buttonNextDisabled} onClick={() => {
                        this.sendOutput();
                    }}>CONFERMA</Button>;
                </div>
            </div>
            }}/>, <Media query="(max-width: 1064px)" render={() => {
                return <div id={"main-cropper-container"}>
                    <div id={"image-cropper-main-container-header"} onClick={() => this.props.closeFunctionWithResult(this.buildResult(false, undefined))}>
                        <CloseMenuIcon width={'21px'} height={'21px'} fill={'#FFFFFF'} />
                    </div>
                    {<Cropper
                        src={this.state.imageDesktop}
                        // Cropper.js options
                        style={{
                            height: 350,
                            width: "96%",
                            margin: "0 auto",
                        }}
                        initialAspectRatio={16/9}
                        guides={false}
                        center={true}
                        background={false}
                        responsive={true}
                        crop={this._crop.bind(this)}
                        onInitialized={this.onCropperInit.bind(this)}
                        cropBoxResizable={true}
                        cropBoxMovable={true}
                        zoomable={false}
                        movable={true}
                        rotatable={false}
                        toggleDragModeOnDblclick={false}
                        viewMode={2}
                        aspectRatio={1}
                        modal={true}
                        minCropBoxHeight={600}
                        minCropBoxWidth={600}
                    />}
                    <div id={"image-cropper-button-container"}> 
                        <Button id={"image-cropper-button-confirm"} disabled={this.state.buttonNextDisabled} onClick={() => {
                            this.sendOutput();
                        }}>CONFERMA</Button>;
                    </div>
                </div>
                }}/>]
    }

}